export default __webpack_public_path__ + "img/upload-file.ce00238.svg";